import { Settings, SettingMenuArray } from "./types";

export const initialSettingsState: Settings = {
  currentPage: "account",
  fullPageFlg: false,
  isModal: false,
};
